import { useRef, useState } from "react";

import styled from "styled-components";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardRibbon,
  ChevronUpIcon,
  Flex,
  LinkExternal,
  Heading,
  Image,
  TimerIcon,
  Text,
  TokenPairImage,
  // Box,
} from "@pancakeswap/uikit";
import BigNumber from "bignumber.js";
import { BIG_ZERO } from "utils/bigNumber";
import Balance from "components/Balance";

// import PoolCardHeader from '../PoolCard/PoolCardHeader'
import headerimage from "../../../../assets/images/headerimage.png";
import AprRow from "../PoolCard/AprRow";
import CardFooter from "../../components/PoolCard/CardFooter";
import Stake from '../PoolsTable/ActionPanel/Stake'
import AutoEarningsCell from "../PoolsTable/Cells/AutoEarningsCell";
import AutoHarvestAction from "../PoolsTable/ActionPanel/AutoHarvest";
import drivenx from "../../../../assets/images/drivenx.png";
import { Avatar, Box, Link } from '@mui/material';
import linkforward from "../../../../assets/images/linkforward.svg";
import clock from "../../../../assets/images/clock.svg";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// interface PoolCardProps {
//   pool: any
//   userDataLoaded: boolean
//   account: string
// }

export interface DeserializedPool {
  totalStaked?: BigNumber;
  stakingLimit?: BigNumber;
  stakingLimitEndBlock?: number;
  profileRequirement?: {
    required: boolean;
    thresholdPoints: BigNumber;
  };
  userData?: {
    allowance: BigNumber;
    stakingTokenBalance: BigNumber;
    stakedBalance: BigNumber;
    pendingReward: BigNumber;
  };
}

const StyledTable = styled.div`
  border-radius: ${({ theme }) => theme.radii.card};
  scroll-margin-top: 64px;

  background-color: ${({ theme }) => theme.card.background};
  > div:not(:last-child) {
    border-bottom: 2px solid ${({ theme }) => theme.colors.disabled};
  }
`;

const StyledTableBorder = styled.div`
  background-color: ${({ theme }) => theme.colors.cardBorder};
  padding: 1px 1px 3px 1px;
  background-size: 400% 400%;
`;

export const StyledCard = styled(Card) <{ isFinished?: boolean }>`
  max-width: 352px;
  margin: 0 8px 24px;
  width: 100%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  background-color : #00FED9;
  padding : 1px;
  align-self: baseline;
  position: relative;
  color: ${({ isFinished, theme }) =>
    theme.colors[isFinished ? "textDisabled" : "secondary"]};

  ${({ theme }) => theme.mediaQueries.sm} {
    margin: 0 12px 46px;
  }
`;

const Wrapper = styled(CardHeader)`
  border-radius: ${({ theme }) =>
    `${theme.radii.card} ${theme.radii.card} 0 0`};
  display: flex;
  justify-content: space-between;
  background : #00202F;

`;

const PCardBody = styled(CardBody)`
  background : #1A3342;

`;

const PLinkExternal = styled(LinkExternal)`
  // text-decoration : none;
`

const MainImage = styled.div`
  position: absolute;
  width: 92%;
  inset: 0px auto auto 0px;
  z-index: 5;
`;

const LockDuration = styled(Box)`
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
`;

const Earned = styled.div`
  font-weight: 600;
  font-size: 12px;
  padding-top: 10px;
  display: flex;
  /* justify-content: space-around; */
  text-transform: uppercase;
`;

export const ActionContent = styled.div`
  /* padding: 16px; */
  -webkit-box-flex: 1;
  flex-grow: 1;
  flex-basis: 0px;
  margin-bottom: 16px;
`;
export const ActionTitles = styled.div`
  font-weight: 600;
  font-size: 12px;
`;

const Compound = styled.div`
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
`;
const Buttons = styled(Box)`
  display: flex;
  flex-direction: column;
`;
const HarvestButton = styled(Button)`
  background-color: rgb(233, 234, 235);
  border-color: rgb(233, 234, 235);
  box-shadow: none;
  color: rgb(189, 194, 196);
  cursor: not-allowed;
  align-items: center;
  border: 0px;
  border-radius: 16px;
  display: inline-flex;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  margin-bottom: 4px;
  height: auto;
  padding: 5px 10px;
  font-size: 12px;
`;

const CompoundButtoon = styled(Button)`
  background-color: rgb(233, 234, 235);
  border-color: rgb(233, 234, 235);
  box-shadow: none;
  color: rgb(189, 194, 196);
  cursor: not-allowed;
  align-items: center;
  border: 0px;
  border-radius: 16px;
  display: inline-flex;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  margin-bottom: 4px;
  height: auto;
  padding: 5px 10px;
  font-size: 12px;
`;

const ConnectButton = styled(Button)`
  -webkit-box-align: center;
  align-items: center;
  border: 0px;
  border-radius: 16px;
  box-shadow: rgb(14 14 44 / 40%) 0px -1px 0px 0px inset;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  height: 48px;
  padding: 0px 24px;
  background-color: rgb(15, 33, 49);
  color: white;
  width: 100%;
`;
const Cardfooterfontsz = styled(Box)`
  font-size: 14px;
`;
const PoolCard: React.FC<{ pool?: any; account: string, index?: any, price: number }> = ({
  pool,
  index,
  account,
  price
}) => {
  // console.log(account)
  const { sousId, stakingToken, earningToken, isFinished, userData } = pool;
  const stakedBalance = userData?.stakedBalance
    ? new BigNumber(userData.stakedBalance)
    : BIG_ZERO;
  const accountHasStakedBalance = stakedBalance.gt(0);
  const [isExpanded, setIsExpanded] = useState(false)
  // const tableWrapperEl = useRef<HTMLDivElement>(null)

  return (
    // isFinished={isFinished && sousId !== 0}
    // ribbon={isFinished && <CardRibbon variantColor="textDisabled" text={('Finished')} />}
    // {pools.map((pool)=>(
    <StyledCard>
      <Wrapper>
        {/* <Flex alignItems="center" justifyContent="space-between">
                    123
                </Flex> */}
        <Flex flexDirection="column">
          <Text fontSize="24px" bold color="#00FED9" marginBottom={"0px"}>
            Earn {pool.name}
          </Text>
          <Text fontSize="16px" color="#B1B3CB">
            Stake {pool.symbol}
          </Text>
        </Flex>
        {/* <img
          src={drivenx}
          style={{ borderRadius: "50%" }}
          width={64}
          height={64}
        /> */}
        <Box sx={{ position: 'relative', mr: 2 }}>
          <Avatar sx={{ width: "60px", height: "60px", borderRadius: "50%", border: '1px solid', borderColor: '#00FED9' }} src={drivenx} alt="drivenx" variant="rounded"></Avatar>
          <Avatar sx={{ position: 'absolute', top: '50%', left: '55%', width: "35px", height: "35px", borderRadius: "50%", border: '1px solid', borderColor: '#00FED9' }} src={drivenx} alt="drivenx" variant="rounded"></Avatar>
        </Box>
      </Wrapper>
      <PCardBody>
        <AprRow pool={pool} index={index} stakedBalance={stakedBalance} />
        <Flex mt="24px" flexDirection="column">
          <Stake pool={pool} price={price} />
          <AutoHarvestAction pool={pool} />
        </Flex>
      </PCardBody>
      <CardFooter pool={pool} account={account} setIsExpanded={setIsExpanded} isExpanded={isExpanded} />
      {isExpanded && (
        <>
          <Box sx={{ background: '#1A3342' }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", px: 3, pr: 3, color: "#B1B3CB" }}>
              <Cardfooterfontsz>
                Total staked:
              </Cardfooterfontsz>
              <Cardfooterfontsz sx={{ color: 'white' }}>
                <Balance
                  mt="4px"
                  color='white'
                  fontSize='14px'
                  decimals={0}
                  prefix=""
                  value={pool.totalStaked}
                  unit={` ${pool.name}`}
                />
              </Cardfooterfontsz>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", px: 3, pr: 1.5, pt: "4px", color: "#B1B3CB" }}>
              <Box sx={{ display: 'flex', }}>
                <Cardfooterfontsz>
                  Ends in:
                </Cardfooterfontsz>
              </Box>
              <a target="_blank" rel="noreferrer noopener" href={`https://bscscan.com/block/countdown/${pool.bounsEnd.toString()}`} color="#00FED9" className="sc-gsnTZi sc-cOFTSb ijQNjp dEGPWF sc-ciicml fmQDYl">
                <div font-size="14px" color="white" className="sc-gsnTZi eVEqC">
                {pool.endsin} {'Blocks'}
                </div>
                <TimerIcon ml="4px" color="#00FED9" />
              </a>  
            </Box>
            <Flex mb="2px" justifyContent={['flex-end', 'flex-end', 'flex-end']} mr="3" pt="4px">
              <PLinkExternal href={'https://bscscan.com/token/0x6db3972c6a5535708e7a4f7ad52f24d178d9a93e'} bold={false} color='#00FED9'>
                <Text fontSize="14px" color='white' >
                  See Token Info
                </Text>
              </PLinkExternal>
            </Flex>
            <Flex pb="20px" justifyContent={['flex-end', 'flex-end', 'flex-end']} mr="3" pt="4px">
              <PLinkExternal href={'https://www.drivenecosystem.com/ '} color='#00FED9'>
                <Text fontSize="14px" color='white' >
                  View Project Site
                </Text>
              </PLinkExternal>
            </Flex>
          </Box>
        </>
      )}
    </StyledCard>
    // ))} 
  );
};

export default PoolCard;
